<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tên khu vực</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập (tối đa 255 ký tự)"
            maxLength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-2">
          <label class="txt-right required">Nhà máy/ trang trại</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            readonly
            :multiple="false"
            :limit="factory_obj.limit"
            :loading="factory_obj.loading"
            v-model="factory"
            :options="factory_obj.items"
            :total="factory_obj.total"
            onlyClick
            @scroll="emitEventFactory"
            @offset="changeOffsetFactory"
          />
          <input class="input_tmp_validator" id="factory_add" />
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" />Hiển thị
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";

export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      filters: {},
      name: "",
      active: true,
      company: {},
      company_id : null,
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      factory : {},
      factory_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
    };
  },
  async mounted() {
      await this.getListCompany();
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
          this.company = this.model.company;
          this.active = this.model.active;
          this.name = this.model.name;
          this.factory = this.model.factory;
          this.factory = { id: this.model.factory.id, name: this.model.factory.name };
      } else {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.$set(this, 'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
              this.company = { id: this.company_id };
          }
      }
  },
  watch: {
    async "company_id"() {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.company = {id: this.company_id};
              await this.getListFactory();
          }
      },
      async "$store.getters.company_id"() {
          if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
              this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
              this.company = {id: this.company_id};
              await this.getListFactory();
          }
      },
    async "company"() {
      if(this.mode == 'add'){
        this.factory = null;
        await this.clearChangeCompany()
      }
      await this.getListFactory();
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      } 
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.factory_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        };
        return;
      }
      if (this.mode == "add") {
        await this.clearChangeCompany();
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        this.factory_obj.loading = true;
        await ApiRepository.post("/_api/factory/options", { filters: this.factory_obj.filters, limit: this.factory_obj.limit, offset: this.factory_obj.offset, company_id: this.company.id }, {headers}).then((res) => {
          var tmp = res.data.data?.factory;
          if (this.factory_obj.offset > 0 ) {
            this.factory_obj.items.push(...tmp);
          } else{
            this.factory_obj.items = tmp;
          }
          this.factory_obj.total = res.data.data.count;
          this.factory_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.factory_obj.loading = false;
        })
      }
    },
    async clearChangeCompany(){
      this.factory_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.factory = [];
    },
    async emitEventFactory(keyword) {
      console.log("keyword", keyword);
      this.getListFactory();
    },
    changeOffsetFactory(value) {
          this.factory_obj.offset = value;
      },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Vui lòng chọn công ty!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let factory_add = document.getElementById("factory_add");
      if (this.$commonFuction.isEmptyObject(this.factory) || this.factory.length == 0) {
        factory_add.setCustomValidity("Vui lòng chọn nhà máy!");
      } else {
        factory_add.setCustomValidity("");
      }

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Vui lòng nhập tên khu vực!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên khu vực không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        active: this.active,
        company: this.company,
        factory : this.factory,
      };
      console.log("saveData", params);
      this.$emit("save", params);
    }, 
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
